import React from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faEnvelope, faFilePdf } from '~components/icon';

const CoContributionExportActions = () => {
  const handleGeneratePdf = () => {
    // TODO: Implement PDF generation (TAV-1881)
  };

  const handleEmailPdf = () => {
    // TODO: Implement email PDF (TAV-1881)
  };

  return (
    <div className="d-flex gap-2">
      <ClickableIcon icon={faFilePdf} id="generate-pdf" onClick={handleGeneratePdf} toolTip="Generate PDF" />
      <ClickableIcon icon={faEnvelope} id="email-pdf" onClick={handleEmailPdf} toolTip="Email PDF" />
    </div>
  );
};

export default CoContributionExportActions;
